module.exports = __webpack_public_path__ + "static/assets/70e417992f5412c157e6ca693589cbc6.png";